// extracted by mini-css-extract-plugin
export default {"range":"style_range__UG3LH","dash":"style_dash__3cpQ2"};